import { useMemo } from "react";
import { AioIconButton } from "../additional/aioIconButton";
import { useTableContext } from "./TableContextProvider";
import { REMOVE_COLUMN } from "./functions/interface";

interface AitRemoveColumnButtonProps {
  originalColumnIndex: number;
}

/**
 * Button to remove a column; gathers affected cell ids before dispatch.
 *
 * @param props - Component props
 * @param props.originalColumnIndex - The original source index of the column before any reordering
 */
export const AitRemoveColumnButton = ({
  originalColumnIndex: originalColumnIndex,
}: AitRemoveColumnButtonProps) => {
  const { state, dispatch } = useTableContext();

  const cellIds: string[] = useMemo(() => {
    if (!state) return [];
    return [
      ...(state.originalTableData.headerData !== false
        ? state.originalTableData.headerData.rows.flatMap((r) => r.cells[originalColumnIndex].aitid)
        : []),
      ...state.originalTableData.bodyData.flatMap((rg) =>
        rg.rows.flatMap((r) => r.cells[originalColumnIndex].aitid),
      ),
    ];
  }, [state, originalColumnIndex]);

  return !state ? null : (
    <AioIconButton
      id={`${state.id}-remcol-${originalColumnIndex}`}
      tipText="Remove column"
      iconName="aioxMinus"
      onClick={() => {
        dispatch({
          operation: REMOVE_COLUMN,
          value: originalColumnIndex,
          cellIds,
        });
      }}
    />
  );
};

AitRemoveColumnButton.displayName = "AitRemoveColumnButton";
